import { createContext } from 'react';

export interface IWithProgress {
  value: number;
}

export const ProgressContext = createContext<IWithProgress>({
  value: 0,
});

export const ProgressProvider = ProgressContext.Provider;
